import { fetchPost } from './fetch';
import { AudioDto } from './type';

interface Project {
  folderId: number;
  format: string;
  model: string;
  assist: boolean;
  tracks: Track[];
}

interface Track {
  audioId: string;
  prompt: string;
  trackName: string;
  clips: Clip[];
}

interface Clip {
  startTime: number;
  endTime: number;
  effects: Effect[];
}

interface Effect {
  type: string;
  params: Params;
}

interface Params {
  duration: number; // < 60s for refill, intro, outro
  startTime?: number; // s, >= 10s for refill
  endTime?: number; // <= 50 for refill
  keepTimes?: number; // < 60 for intro, outro
}

export type EditorRequestDTO = {
  data?: Project;
};

export type EditorResponseDTO = {
  data?: AudioDto[];
  creditBalance: number;
  error?: {
    errorMessage: string;
    errorCode: string;
    statusCode: number;
    timestamp: string;
  };
};

const API_URL = '/api/v2/audio';

export const postAudioGenerateEditor = async (req: EditorRequestDTO): Promise<EditorResponseDTO> => {
  const url = `${API_URL}/edit`;
  return fetchPost<EditorRequestDTO, EditorResponseDTO>(url, req);
};
